<template>
    <div class="side">
        <logo></logo>
        <rank :ranks="ranks"></rank>
    </div>
</template>
<script>
import Logo from '@/components/Logo'
import Rank from '@/components/Rank'

export default {
    components: {Logo,Rank},
    name: 'Side',
    props: ['ranks']
}
</script>
<style>
.side{

background: rgba(40,110,103,1);
background: -moz-linear-gradient(-45deg, rgba(40,110,103,1) 0%, rgba(97,226,149,1) 100%);
background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(40,110,103,1)), color-stop(100%, rgba(97,226,149,1)));
background: -webkit-linear-gradient(-45deg, rgba(40,110,103,1) 0%, rgba(97,226,149,1) 100%);
background: -o-linear-gradient(-45deg, rgba(40,110,103,1) 0%, rgba(97,226,149,1) 100%);
background: -ms-linear-gradient(-45deg, rgba(40,110,103,1) 0%, rgba(97,226,149,1) 100%);
background: linear-gradient(135deg, rgba(40,110,103,1) 0%, rgba(97,226,149,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#286e67', endColorstr='#61e295', GradientType=1 );
    /* background: url(../assets/bg-sale.png); */
    background-size:cover;
    min-height: 100%;
    /* border: solid 1px transparent; */
}
</style>




// WEBPACK FOOTER //
// src/components/Side.vue